export let WidgetName = /*#__PURE__*/function (WidgetName) {
  WidgetName["CALENDAR_WIDGET"] = "CALENDAR_WIDGET";
  WidgetName["CALENDAR_PAGE"] = "CALENDAR_PAGE";
  WidgetName["SERVICE_LIST_WIDGET"] = "SERVICE_LIST_WIDGET";
  WidgetName["SERVICE_LIST_PAGE"] = "SERVICE_LIST_PAGE";
  WidgetName["SERVICE_PAGE"] = "SERVICE_PAGE";
  WidgetName["WEEKLY_TIMETABLE"] = "WEEKLY_TIMETABLE";
  WidgetName["DAILY_AGENDA"] = "DAILY_AGENDA";
  return WidgetName;
}({});
export const isCalendarWidget = widgetName => widgetName === WidgetName.CALENDAR_WIDGET;
export const isCalendarPage = widgetName => widgetName === WidgetName.CALENDAR_PAGE;
export const isServiceListWidget = widgetName => widgetName === WidgetName.SERVICE_LIST_WIDGET;
export const isServiceListPage = widgetName => widgetName === WidgetName.SERVICE_LIST_PAGE;
export const isServicePage = widgetName => widgetName === WidgetName.SERVICE_PAGE;
export const isWeeklyTimetable = widgetName => widgetName === WidgetName.WEEKLY_TIMETABLE;
export const isDailyAgenda = widgetName => widgetName === WidgetName.DAILY_AGENDA;
//# sourceMappingURL=widgetName.js.map